import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';

import { AsyncPipe, NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { ShIconComponent } from '../../../../elements/components/icon/icon.component';
import { ShAutoFocusDirective } from '../../../../elements/directives/auto-focus/auto-focus.directive';
import { ShClickOutsideDirective } from '../../../../elements/directives/click-outside/click-outside.directive';
import { ShDynamicResizeDirective } from '../../../../elements/directives/dynamic-resize/dynamic-resize.directive';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormTagListComplexBaseComponent } from '../base-complex/form-tag-list-complex-base.component';

@Component({
    selector: 'sh-form-tag-list-base',
    templateUrl: '../base-complex/form-tag-list-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormTagListBaseComponent)],
    standalone: true,
    imports: [
        ShClickOutsideDirective,
        NgIf,
        NgTemplateOutlet,
        ShActionItemComponent,
        ReactiveFormsModule,
        NgFor,
        ShIconComponent,
        NgClass,
        AsyncPipe,
        ShAutoFocusDirective,
        ShDynamicResizeDirective
    ]
})
export class ShFormTagListBaseComponent extends ShFormTagListComplexBaseComponent implements OnInit {
    constructor(
        ref: ChangeDetectorRef,
        protected formBuilder: UntypedFormBuilder
    ) {
        super(ref);
    }

    propagateChange(formValues: FormValue<string>[]): void {
        const unwrapped: string[] = formValues
            .filter(formValue => formValue.state === FormValueState.SET)
            .map(formValue => FormValue.unwrap(formValue));
        super.propagateSimpleChange(unwrapped);
    }

    writeValue(values: string[]): void {
        if (values instanceof Array === false) {
            super.writeValue([]);
            return;
        }
        const converted: FormValue<string>[] = values.map(value => FormValue.wrap(value));
        super.writeValue(converted);
    }
}
